import { inject, provide } from 'vue'
import { Overview } from '@deepcloud/api-deep-box'
import type { InjectionKey } from 'vue'

type InjectionData =
  Ref<Overview | undefined> | ComputedRef<Overview | undefined>

const KEY = Symbol('ContextBoxOverview') as InjectionKey<InjectionData>

export function createContextBoxOverview(injectionData: InjectionData) {
  provide(KEY, injectionData)
}

export function useContextBoxOverview() {
  const overview = inject(KEY)
  if (!overview) {
    throw new Error(
      'Please call `createContextBoxOverview` on the appropriate parent component',
    )
  }

  const types = computed(() => overview.value?.deepBoxes || [])

  const sharedBoxes = computed(() => overview.value?.sharedWithMe?.boxes || [])

  const hasShareBoxes = computed(() => sharedBoxes.value.length > 0)

  const boxesTotalCount = computed(() => {
    let count = 0
    count += types.value.flatMap((type) => type.size).reduce((a, b) => a + b, 0)
    count += sharedBoxes.value.length
    return count
  })

  return { overview, hasShareBoxes, boxesTotalCount }
}
